import { Navbar, Nav } from 'react-bootstrap';
import SocialIcons from './SocialIcons';

function Menu() {
  const elements = [
    {
      name: 'INÍCIO',
      path: '#inicio'
    },
    {
      name: 'PORTFÓLIO',
      path: '#portfolio'
    },
    {
      name: 'CLIENTES',
      path: '#clientes'
    },
    {
      name: 'SERVIÇOS',
      path: '#servicos'
    },
    {
      name: 'CONTATO',
      path: '#contato'
    },
    {
      name: 'ORÇAMENTO',
      path: 'https://wa.me/14997965327',
      class: 'call-button',
      target: '_blank'
    }
  ]

  return (
    <>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav" className="menu">
        <Nav className="mx-auto">
          {elements.map((element, index) => (
            <Nav.Link key={index} target={element.target} href={element.path} className={element.class}>{element.name}</Nav.Link>
          ))}
        </Nav>
        <SocialIcons />
      </Navbar.Collapse>
    </>
  )
}

export default Menu